import React from "react";
import { useLocation } from "react-router-dom";
import { useOktaAuth } from "@okta/okta-react";
import { Box, CircularProgress } from "@mui/material";
import { useAuth } from "./useAuth";
import LoginPage from "../pages/LoginPage";

export default function RequiredAuth({
  children,
}: {
  children: React.ReactNode;
}): React.ReactElement {
  const { oktaAuth, authState } = useOktaAuth();
  const auth = useAuth();
  const location = useLocation();

  const handleSignIn = () => {
    void oktaAuth.signInWithRedirect({ originalUri: window.location.pathname });
  };

  if (location.pathname === "/login/callback") {
    return <>{children}</>;
  }

  if (auth.isAuthenticated) {
    return <>{children}</>;
  }

  if (!authState) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        minHeight="100vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!authState.isAuthenticated) {
    return (
      <LoginPage
        onSignIn={handleSignIn}
        onLocalLogin={auth.onLocalLogin}
      />
    );
  }

  return <>{children}</>;
}
